import {Paper, styled} from "@mui/material";

export const Item = styled(Paper)(({theme}) => ({
    backgroundImage: null,
    padding: theme.spacing(1),
    textAlign: 'center',
}));